import { BaseStoreAssets, createBaseStoreAssets, createStoreAssets } from '@studiohyperdrive/ngx-store';

import { MandateEntity } from '@vlaio/mandates/shared';
import { ProductEntity, RequestSuccessResultEntity } from '@vlaio/shared/types';

import { SelfRegistrationStoreSlice } from './interfaces';

export type ApplicationStoreSliceType = {
	product: BaseStoreAssets<ProductEntity>;
	mandateToRequest: BaseStoreAssets<Partial<MandateEntity>>;
	handlingRequest: BaseStoreAssets<boolean>;
	requestResult: BaseStoreAssets<RequestSuccessResultEntity>;
};

export const { actions, reducers, selectors } = createStoreAssets<ApplicationStoreSliceType>(
	SelfRegistrationStoreSlice.Application,
	[
		{
			subSlice: 'product',
			generator: createBaseStoreAssets<ProductEntity>
		},
		{
			subSlice: 'mandateToRequest',
			generator: createBaseStoreAssets<Partial<MandateEntity>>
		},
		{
			subSlice: 'handlingRequest',
			generator: createBaseStoreAssets<boolean>
		},
		{
			subSlice: 'requestResult',
			generator: createBaseStoreAssets<RequestSuccessResultEntity>
		}
	]
);
